export default function SVGPlay(props: any) {
    return (
        <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="icon_replay">
                <g id="Group 128720752">
                    <g id="&#233;&#161;&#181;&#233;&#157;&#162;-1">
                        <g id="Apple-TV">
                            <g id="icon-replay">
                                <path
                                    id="&#230;&#164;&#173;&#229;&#156;&#134;&#229;&#189;&#162;"
                                    d="M84.75 44.875C84.75 66.8974 66.8974 84.75 44.875 84.75C22.8526 84.75 5 66.8974 5 44.875C5 22.8526 22.8526 5 44.875 5C66.8974 5 84.75 22.8526 84.75 44.875Z"
                                    stroke="white"
                                    strokeWidth="2"
                                />
                            </g>
                        </g>
                    </g>
                    <path
                        id="Vector 8"
                        d="M34 61.1305V30.6798C34 29.094 35.7572 28.139 37.0878 29.0015L59.5252 43.5451C60.7114 44.314 60.7473 46.0374 59.5941 46.855L37.1567 62.762C35.8323 63.701 34 62.754 34 61.1305Z"
                        fill="white"
                    />
                </g>
            </g>
        </svg>
    );
}
